module.exports = __webpack_public_path__ + "img/logoTele.879d84f2.svg";